import {
	type FetchStakingOngoingUserParticipationsParams,
	getHttpClient,
	SociosApi,
	StakingApi
} from '@capsicum/common';

import { type LockerRoomUnlock } from '../../models';

export const stakingApi = getHttpClient.then(client => new StakingApi(client));

export async function fetchStakingOngoingUserParticipations(params: FetchStakingOngoingUserParticipationsParams) {
	return (await stakingApi)
		.fetchStakingOngoingUserParticipations(params, {
			headers: SociosApi.prepareEDTOHeaders([
				{
					at: '/data/*/rewards/*/reward/externalId',
					fetch: 'NftService:CollectibleDefinition:byId',
					into: 'nft'
				}
			])
		})
		.then(res => res.data) as Promise<Array<LockerRoomUnlock>>;
}
